import { slotVFrom } from "@/utils/vformSlot";
export function slotArrayList() {
  return [
    {
      name: "ceshi4",
      compontent: () => import("@/CommonDP/components/vformSlot/demo.vue")
    },
    ...slotVFrom
  ];
}

